import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	contentChildren,
	CUSTOM_ELEMENTS_SCHEMA,
	input,
	model,
} from '@angular/core';

import { TabMenuItemDirective } from './tab-menu.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-tab-menu`,
	templateUrl: './tab-menu.html',
	imports: [CommonModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TabMenuComponent {
	activeTab = model(0);

	useButtonVariant = input(false);
	// Is only being used if useButtonVariant is true
	numberOfColumns = input<2 | 3 | 4>(3);
	// Is only being used if useButtonVariant is true
	hideTabs = input(false);

	tabMenuItems = contentChildren(TabMenuItemDirective);

	// Is only being used if useButtonVariant is true
	numberOfColumnsTab = computed<string>(() => {
		switch (this.numberOfColumns()) {
			case 2:
				return 'md:grid-cols-2';
			case 3:
				return 'md:grid-cols-3';
			case 4:
				return 'md:grid-cols-4';
		}
	});

	tabNames = computed<string[]>(
		() => this.tabMenuItems()?.map((item) => item.name) || [],
	);

	setActiveTab(tabIndex: number) {
		this.activeTab.set(tabIndex);
	}
}
